import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Twitter } from "lucide-react";
import { BRAND, SERVICE_CATEGORIES } from "../data/site";

export default function Footer() {
  return (
    <footer className="hero-gradient noise-overlay relative text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/assets/logo.png" alt="Neat & Proper logo" className="h-12 w-12 rounded-xl bg-white object-cover" />
              <div>
                <p className="font-display font-extrabold text-lg">Neat &amp; Proper</p>
                <p className="text-xs text-white/60">{BRAND.descriptor}</p>
              </div>
            </div>
            <p className="text-brand-gold font-display italic text-lg mb-3">{BRAND.tagline}</p>
            <p className="text-white/70 text-sm leading-relaxed">
              Lagos' trusted premium cleaning company — residential, commercial, events and everything in between.
            </p>
            <div className="flex gap-3 mt-5">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-social-facebook" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-lime flex items-center justify-center transition-colors"><Facebook className="w-4 h-4" /></a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-social-instagram" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-lime flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter" data-testid="footer-social-twitter" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-lime flex items-center justify-center transition-colors"><Twitter className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="font-display font-bold mb-4 text-brand-gold tracking-wide text-sm uppercase">Services</h4>
            <ul className="space-y-2.5 text-sm">
              {SERVICE_CATEGORIES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services#${s.slug}`} className="text-white/70 hover:text-brand-lime transition-colors">{s.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold mb-4 text-brand-gold tracking-wide text-sm uppercase">Company</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/pricing" className="text-white/70 hover:text-brand-lime transition-colors">Pricing &amp; Plans</Link></li>
              <li><Link to="/booking" className="text-white/70 hover:text-brand-lime transition-colors">Book a Cleaning</Link></li>
              <li><Link to="/blog" className="text-white/70 hover:text-brand-lime transition-colors">Blog &amp; Tips</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-brand-lime transition-colors">Contact Us</Link></li>
              <li><Link to="/admin/login" className="text-white/70 hover:text-brand-lime transition-colors" data-testid="footer-admin-link">Admin Login</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold mb-4 text-brand-gold tracking-wide text-sm uppercase">Get In Touch</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-brand-lime shrink-0" /> <a href={BRAND.phoneHref} className="hover:text-brand-lime">{BRAND.phone}</a></li>
              <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-brand-lime shrink-0" /> <a href={`mailto:${BRAND.email}`} className="hover:text-brand-lime break-all">{BRAND.email}</a></li>
              <li className="flex items-center gap-3"><MapPin className="w-4 h-4 text-brand-lime shrink-0" /> {BRAND.location} — Island &amp; Mainland</li>
              <li className="flex items-center gap-3"><Clock className="w-4 h-4 text-brand-lime shrink-0" /> {BRAND.hours}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Neat &amp; Proper — Premium Cleaning &amp; Property Care. All rights reserved.</p>
          <p className="font-display italic text-brand-gold">{BRAND.promise}</p>
        </div>
      </div>
    </footer>
  );
}
